// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Modals__OfferModalController from "./modals/offer_modal_controller";
application.register("modals--offer-modal", Modals__OfferModalController);

import Modals__ModalController from "./modals/modal_controller";
application.register("modals--modal", Modals__ModalController);

import Form__DebounceController from "./form/debounce_controller";
application.register("form--debounce", Form__DebounceController);

import Form__FilterController from "./form/filter_controller";
application.register("form--filter", Form__FilterController);

import Form__AutobiderSubmitController from "./form/autobider_submit_controller";
application.register("form--autobider-submit", Form__AutobiderSubmitController);

import Form__BundleCheckboxController from "./form/bundle_checkbox_controller";
application.register("form--bundle-checkbox", Form__BundleCheckboxController);

import Form__CheckboxToggleController from "./form/checkbox_toggle_controller";
application.register("form--checkbox-toggle", Form__CheckboxToggleController);

import Form__CheckboxAutosubmitController from "./form/checkbox_autosubmit_controller";
application.register("form--checkbox-autosubmit", Form__CheckboxAutosubmitController);

import Form__AutosaveController from "./form/autosave_controller";
application.register("form--autosave", Form__AutosaveController);

import Form__CheckAllController from "./form/check_all_controller";
application.register("form--check-all", Form__CheckAllController);

import Table__OrdeableController from "./table/ordeable_controller";
application.register("table--ordeable", Table__OrdeableController);

import Table__TabController from "./table/tab_controller";
application.register("table--tab", Table__TabController);

import AutotaxCounter from "./autotax_counter_controller";
application.register("autotax-counter", AutotaxCounter);

import InvoiceAutotaxCounter from "./invoice_autotax_counter_controller";
application.register("invoice-autotax-counter", InvoiceAutotaxCounter);

import EnglishOffer from "./english_offers_controller";
application.register("english-offer", EnglishOffer);

import CountDownController from "./countdown_controller";
application.register("countdown", CountDownController);

import TimeleftController from "./timeleft_controller"
application.register("timeleft", TimeleftController)

import ProfileWebpushController from "./profile_webpush_controller";
application.register("profile-webpush", ProfileWebpushController);

import PushNotificationController from "./push_notification_controller";
application.register("push-notification", PushNotificationController);

import ToggleController from "./toggle_controller";
application.register("toggle", ToggleController);

import HamburgerController from "./navbar/hamburger_controller";
application.register("hamburger", HamburgerController);

import ExpandableController from "./navbar/expandable_controller";
application.register("navbar--expandable", ExpandableController);

import CookieConsentController from "./cookie_consent_controller";
application.register("cookie-consent", CookieConsentController);

import GoogleAnalyticsController from "./google_analytics_controller";
application.register("google-analytics", GoogleAnalyticsController);

import AuctionTimezoneController from "./auction_timezone_controller";
application.register("auction-timezone", AuctionTimezoneController);

import DailySummaryController from "./daily_summary_controller";
application.register("daily-summary", DailySummaryController);

import SlashedZeroController from "./slashed_zero_controller";
application.register("slashed-zero", SlashedZeroController);

import OfferPriceValidatorController from "./offer_price_validator_controller";
application.register("offer-price-validator", OfferPriceValidatorController);
